import { HttpClient, jrpcRequest } from '@httpClient/index';
import CerberService from './service';
import { CERBER_BASE_URL, CERBER_JSONRPC_ENTRY_POINT } from './config';
import jrpcConfig from './jrpcConfig';
import ActionNames from './actionNames';

export default (): HttpClient<ActionNames> =>
  new CerberService(jrpcRequest(CERBER_JSONRPC_ENTRY_POINT, jrpcConfig), {
    baseURL: CERBER_BASE_URL,
  });
